// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
var text_fields = {};
var select_fields = {};
import 'core-js';
import 'regenerator-runtime/runtime';
import { Turbo } from "@hotwired/turbo-rails"
import Rails from "@rails/ujs";
import intlTelInput from 'intl-tel-input';
window.Rails = Rails;
window.intlTelInput = intlTelInput;
require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("controllers")
require("channels")
require('jquery')
import 'moment'
require('modules/pie-progress');
require('modules/easy-select')
require('modules/snackbar')
require('modules/onboarding')
require('modules/v2/sign_up')
require('modules/pitch')
require('modules/metrics')
require('modules/admin')
require('modules/video')
require('modules/forms')
require('modules/fundraising')
require('modules/notifications')
require('modules/rewards')
require('modules/stripe')
require('modules/mobile-menus');
require('modules/user');
require('modules/parents');
require("trix")
require("@rails/actiontext")
require('modules/v2/header');
require('modules/v2/navigation');
require('modules/v2/video-center');
require('modules/v2/reward-center');
require('modules/v2/donation_form');
require('modules/v2/public_facing_showcase');
require('modules/v2/pitches')
require('modules/v2/onboarding_wizard')
require('modules/v2/share_component');
require('modules/request-demo');
require('modules/v2/new_pitch');
require('modules/chair-dashboard/tools');
import ClipboardJS from 'modules/clipboard.min'
import Cropper from 'cropperjs';
window.Cropper = Cropper;
import 'trix'

import {MDCFloatingLabel} from '@material/floating-label';
import {MDCTextField} from '@material/textfield';
import {MDCTextFieldIcon} from '@material/textfield/icon';
import {MDCSelect} from '@material/select';
require('inputmask');
import * as Honeybadger from "@honeybadger-io/js";

Honeybadger.configure({
  apiKey: '77f2e178',
  environment: 'production'
})


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
// Support component names relative to this directory:

import '../stylesheets/application.scss'

var text_fields = {};
$(document).on('turbolinks:load', function() {
  new ClipboardJS('.copy-link');
  $('.button__add.modal').on('click', function(e) {
    e.preventDefault();
  });

  $('.mobile-trigger-holder').on('click', function(e) {
    e.preventDefault();
    $('.mobile-trigger-holder, .navigation-menu, body, header').toggleClass('menu-triggered');
  });

  if($('.snackbar').length) {
    $('.snackbar').addClass('snackbar-opened');
    setTimeout(function() {
      $('.snackbar').removeClass('snackbar-opened');
    }, 10000);
  }

  if (document.querySelectorAll(".mdc-text-field").length) {
    const textFields = [].map.call(document.querySelectorAll('.mdc-text-field'), function(el) {
      let field = new MDCTextField(el);
      text_fields[el.querySelector('input, textarea').getAttribute('name')] = field;
      return field
    });
  }

  $('.field_with_errors').closest('.mdc-text-field').addClass('mdc-text-field--invalid')

  if (document.querySelectorAll('.mdc-select').length) {
    const selects = [].map.call(document.querySelectorAll('.mdc-select'), function(el) {
      let select = new MDCSelect(el);
      if(el.querySelector('.mdc-list-item--selected')) {
        el.querySelector('.mdc-select__selected-text').textContent = el.querySelector('.mdc-list-item--selected').textContent;
      }
      select.listen('MDCSelect:change', () => {
        $('.grade-span').hide();
        el.querySelector('.mdc-select__selected-text').textContent = el.querySelector('.mdc-list-item--selected').textContent;
        el.querySelector('.mdc-select--hidden-input').value = select.value;
        if($(el).find('.mdc-list-item--selected').data('token')) {
          $('.registration-link-prompt').hide();
          $('.registration-link').show();
          $('.registration-link code').html($('.registration-link code').data('root-url') + $(el).find('.mdc-list-item--selected').data('token'));
        }
        else {
          $('.registration-link-prompt').show();
          $('.registration-link').hide();
        }
        if($(el).closest('#edit_email_text_modal').length || $(el).closest('#upload_csv_modal').length) {
          $(el).find('input').trigger('change');
        }
      });
      select_fields[el.querySelector('input').getAttribute('name')] = select;
      return select;
    });
  }

  setTimeout(function() {
    $($('.mdc-text-field input').get().reverse()).each(function() {
      if($(this).is(":-webkit-autofill")) {
        text_fields[$(this).attr('name')].foundation.activateFocus();
      }
    })
  }, 400);

  $('.manage-users').on('click', '.edit-link', function(e) {
    e.preventDefault();
    let $modal = $('#edit_user_modal .edit-user-modal'),
      $user = $(this).closest('.user');
    $modal.find('.error-message').text('');
    if($(this).hasClass('email')) {
      $modal.find('form').attr('action', $user.data('update-url'));
      $modal.find('#organization_email_address_first_name').val($user.find('.first-name').text());
      text_fields[$modal.find('#organization_email_address_first_name').attr('name')].foundation.activateFocus();
      $modal.find('#organization_email_address_last_name').val($user.find('.last-name').text());
      text_fields[$modal.find('#organization_email_address_last_name').attr('name')].foundation.activateFocus();
      $modal.find('#organization_email_address_email').val($user.find('.email').text());
      text_fields[$modal.find('#organization_email_address_email').attr('name')].foundation.activateFocus();
      if($user.find('.school-name').length) {
        var $school_select = $modal.find('.school-select');
        $school_select.show();
        $school_select.find('input').prop( "disabled", false );
        setMdcSelectValue($school_select, $user.find('.school-name').text(), $user.data('school-id'));
      }
      if($user.find('.grade').length) {
        var $grade_select = $modal.find('.grade-select');
        setMdcSelectValue($grade_select, $user.find('.grade').text(), $user.find('.grade').text());
      }
    } else {
      $modal.find('#student_id, #invitation_id').val($user.data('id'));
      if($modal.find('#user_id').length) {
        $modal.find('#user_id').val($user.data('user-id'));
      }
      $modal.find('#edit_student_first_name').val($user.find('.first-name').text());
      text_fields[$modal.find('#edit_student_first_name').attr('name')].foundation.activateFocus();
      $modal.find('#edit_student_last_name').val($user.find('.last-name').text());
      text_fields[$modal.find('#edit_student_last_name').attr('name')].foundation.activateFocus();

      $modal.find('#edit_student_telephone').val($user.find('.telephone').text());
      text_fields[$modal.find('#edit_student_telephone').attr('name')].foundation.activateFocus();

      $modal.find('#edit_student_email').val($user.find('.email').text());
      text_fields[$modal.find('#edit_student_email').attr('name')].foundation.activateFocus();
      if($('.manage-users').hasClass('manage-administrators')) {
        $modal.find('.admin-fields').hide();
        $modal.find('.admin-fields input').prop( "disabled", true );
      }
      if($user.find('.school-name').length) {
        var $school_select = $modal.find('.school-select');
        $school_select.show();
        $school_select.find('input').prop( "disabled", false );
        setMdcSelectValue($school_select, $user.find('.school-name').text(), $user.find('.school-name').data('school-id'));
      }
      if($user.find('.district-name').length) {
        var $district_select = $modal.find('.district-select');
        $district_select.show();
        $district_select.find('input').prop( "disabled", false );
        setMdcSelectValue($district_select, $user.find('.district-name').text(), $user.data('invitable-id'));
      }
      if($user.find('.grade').length) {
        var $grade_select = $modal.find('.grade-select');
        setMdcSelectValue($grade_select, $user.find('.grade').text(), $user.find('.grade').text());
      }
    $('input[name="invitation[type]"]').trigger('change');
    }

    $('#edit_user_modal').addClass('visible');
  });

  $('.fundraising-pitch-page').on('change', '#use_donation_email', function() {
    if($(this).is(':checked')) {
      $('#donation_donor_attributes_user_attributes_email').val($('#donation_email').val());
      if($('#donation_email').val() != '') {
        text_fields[$('#donation_donor_attributes_user_attributes_email').attr('name')].foundation.activateFocus();
      }
    }
  });

  $('.fundraising-pitch-page').on('input', '#donation_email', function() {
    if($('#use_donation_email').is(':checked')) {
      $('#donation_donor_attributes_user_attributes_email').val($('#donation_email').val());
      text_fields[$('#donation_donor_attributes_user_attributes_email').attr('name')].foundation.activateFocus();
    }
  });
  ;
  $('.copy-link').on('click', function(e) {
    e.preventDefault();

    var snackbar_stamp = Date.now();
    $('#snackbar-container').append('<div class="snackbar" id="snackbar_' + snackbar_stamp + '">Link Copied!</div>');
    $('#snackbar_' +snackbar_stamp).addClass('snackbar-opened');
      setTimeout(function() {
        $('#snackbar_' +snackbar_stamp).removeClass('snackbar-opened');
      }, 10000);
  });

});


function setMdcSelectValue ($container, text, value) {
  //console.log(value);
  $container.find('.mdc-select__selected-text').text(text);
  $container.find('.mdc-select--hidden-input').val(value);
  $container.find('.mdc-notched-outline').addClass('mdc-notched-outline--notched');
  $container.find('.mdc-floating-label').addClass('mdc-floating-label--float-above');
}

